module.exports = __webpack_public_path__ + "media/images/crm/icon-megaphone-f12c663726d452a7a77c6221eb541f6a.png";